import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PAYMENTS_PUBLIC_DOWNLOAD_RECEIPT_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetReceiptPdfPayload, GetReceiptPdfResult } from '../types/getReceipt.types';

export const PAYMENTS_PUBLIC_RECEIPT_PDF = 'PaymentPublicReceiptPdf';
export const getPublicReceiptPdf = (builder: BuilderType) =>
  builder.query<GetReceiptPdfResult, GetReceiptPdfPayload>({
    providesTags: [PAYMENTS_PUBLIC_RECEIPT_PDF],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_PAYMENTS_PUBLIC_DOWNLOAD_RECEIPT_URL,
    }),

    transformResponse: (response: GenericApiResponse<GetReceiptPdfResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
